import React, { useEffect, useState, useRef } from 'react';
import { GripVertical } from 'lucide-react';
interface ResizablePanelProps {
  children: React.ReactNode;
  defaultWidth?: number;
  minWidth?: number;
  maxWidth?: number;
  side?: 'left' | 'right';
}
export function ResizablePanel({
  children,
  defaultWidth = 320,
  minWidth = 280,
  maxWidth = 600,
  side = 'left'
}: ResizablePanelProps) {
  const [width, setWidth] = useState(defaultWidth);
  const [isResizing, setIsResizing] = useState(false);
  const panelRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      if (!isResizing || !panelRef.current) return;
      const panelRect = panelRef.current.getBoundingClientRect();
      let newWidth: number;
      if (side === 'left') {
        newWidth = e.clientX - panelRect.left;
      } else {
        newWidth = panelRect.right - e.clientX;
      }
      // Constrain width
      newWidth = Math.max(minWidth, Math.min(maxWidth, newWidth));
      setWidth(newWidth);
    };
    const handleMouseUp = () => {
      setIsResizing(false);
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
    };
    if (isResizing) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
      document.body.style.cursor = 'col-resize';
      document.body.style.userSelect = 'none';
    }
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isResizing, side, minWidth, maxWidth]);
  const handleMouseDown = () => {
    setIsResizing(true);
  };
  return <div ref={panelRef} className="relative flex" style={{
    width: `${width}px`,
    flexShrink: 0
  }} data-id="element-1822">
      {children}

      {/* Resize Handle */}
      <div onMouseDown={handleMouseDown} className={`
          absolute top-0 ${side === 'left' ? 'right-0' : 'left-0'} bottom-0 w-1
          hover:w-1.5 bg-transparent hover:bg-brand-purple/50
          cursor-col-resize transition-all group z-10
        `} data-id="element-1823">
        <div className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 left-1/2 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-1824">
          <div className="bg-background-elevated border border-border-subtle rounded p-1 shadow-lg" data-id="element-1825">
            <GripVertical size={12} className="text-text-secondary" data-id="element-1826" />
          </div>
        </div>
      </div>
    </div>;
}